import { get, post } from '../axios'

// 获取jira全部项目
export function v1_jira_getAllProjects_get(map, option) {
  return get(
    `${process.env.VUE_APP_V1}/v1/jira/getAllProjects`,
    map,
    option
  ).then(response => response)
}

// 通过项目ID获取项目详情
export function v1_jira_getProjectById_post(map, option) {
  return post(
    `${process.env.VUE_APP_V1}/v1/jira/getProjectById`,
    map,
    option
  ).then(response => response)
}

// 获取jira上未解决问题
export function v1_jira_getUnResolved_post(map, option) {
  return post(
    `${process.env.VUE_APP_V1}/v1/jira/getUnResolved`,
    map,
    option
  ).then(response => response)
}

// 通过jql查询相关信息
export function v1_jira_searchByJQL_post(map, option) {
  return post(
    `${process.env.VUE_APP_V1}/v1/jira/searchByJQL`,
    map,
    option
  ).then(response => response)
}
